import { Renderer2 } from '@angular/core';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common";
export class ScriptService {
    constructor(document) {
        this.document = document;
    }
    // TODO: eliminar metodo para usar el metodo "loadScript(...)"
    loadFacebookScript(renderer, src) {
        const script = renderer.createElement('script');
        script.src = src;
        script.async = true;
        script.defer = true;
        renderer.appendChild(this.document.body, script);
        return script;
    }
    loadScript(data) {
        const script = this.document.createElement('script');
        script.id = data.id;
        script.src = data.src;
        script.type = 'text/javascript';
        script.async = data.async;
        script.defer = data.defer;
        document.getElementsByTagName('head')[0].appendChild(script);
        return script;
    }
    loadScriptWithPromise(data) {
        return new Promise((resolve, reject) => {
            const script = this.document.createElement('script');
            script.id = data.id;
            script.src = data.src;
            script.type = 'text/javascript';
            script.async = data.async;
            script.defer = data.defer;
            script.onload = () => {
                resolve();
            };
            script.onerror = () => {
                reject(new Error('Could not load the script.'));
            };
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    }
    getDataDopplerChatbot() {
        return {
            id: 'ze-snippet',
            src: 'https://static.zdassets.com/ekr/snippet.js?key=d551604b-d03b-44e4-9ba6-7fdc92f56cb9',
        };
    }
}
ScriptService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ScriptService_Factory() { return new ScriptService(i0.ɵɵinject(i1.DOCUMENT)); }, token: ScriptService, providedIn: "root" });
